import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Steps, Form, Input, InputNumber, Select, Button, Row, Col, Divider, message } from "antd";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { Modal } from 'react-bootstrap';
import { BASE_API } from "../Config/Config";
import { allowAddressCharacters, allowEmailCharacters, allowEnglishTamilWithSpace, allowEnglishTamilWithSpaceAndDot, allowLettersNumbersUnicodeWithSpace, allowNumbersWithSpace, allowOnlyNumbers, allowPhoneCharacters, isValidGoogleMapsEmbedUrl, isValidSixDigitPincode, isValidTenDigitPhone } from "../utils/validations";
import { authenticatedFetch } from "../api/fetchprivateapi";

const { Option } = Select;

const NewWarehouse = ({ show, region, handleCanvaClose, fetchWarehouselist }) => {
    const { t } = useTranslation();
    const [currentStep, setCurrentStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const [step1Values, setStep1Values] = useState(null);

    const [userForm] = Form.useForm();
    const [warehouseForm] = Form.useForm();

    const [showVideo, setShowVideo] = useState(false);

    const handleNext = async () => {
        try {
            const values = await userForm.validateFields();
            setStep1Values(values);
            setCurrentStep(1);
        } catch (error) {
            console.log("Validation Failed:", error);
        }
    };

    // const handleWarehouse = async () => {
    //     const warehouseValues = await warehouseForm.validateFields();

    //     if (!isValidGoogleMapsEmbedUrl(warehouseValues.map)) {
    //         message.error("Please enter a valid Google Maps embed URL.");
    //         return;
    //     }

    //     try {
    //         setLoading(true);


    //         if (!step1Values) {
    //             console.error("Step 1 values missing!");
    //             setLoading(false);
    //             return;
    //         }

    //         const formData = new FormData();

    //         // User values
    //         formData.append("name", step1Values.name);
    //         formData.append("email", step1Values.email);
    //         formData.append("phone_no", step1Values.phone);
    //         formData.append("password", step1Values.password);
    //         formData.append("role", step1Values.role);

    //         // Warehouse values
    //         formData.append("region", warehouseValues.region);
    //         formData.append("wh_name", warehouseValues.warehouseName);
    //         formData.append("map", warehouseValues.map || "");
    //         formData.append("address", warehouseValues.address);
    //         formData.append("district", warehouseValues.district || "");
    //         formData.append("pincode", warehouseValues.pincode || "");
    //         formData.append("ofc_phn", warehouseValues.ofc_phone || "");
    //         formData.append("total_capacity", warehouseValues.total_capacity);

    //         const response = await fetch(`${BASE_API}/apis/CreateWarehouse.php`, {
    //             method: "POST",
    //             body: formData,
    //             credentials: "include"
    //         });

    //         const result = await response.json();

    //         if (result.status === "success") {
    //             Swal.fire({
    //                 icon: "success",
    //                 title: t("successTitle"),
    //                 text: result.message || t("createWarehouse") + " " + t("successTitle"),
    //                 confirmButtonColor: "#3085d6",
    //                 confirmButtonText: "OK",
    //             });

    //             userForm.resetFields();
    //             warehouseForm.resetFields();
    //             setCurrentStep(0);
    //             handleClose();
    //             fetchWarehouselist();

    //         } else {
    //             Swal.fire({
    //                 icon: "error",
    //                 title: t("errorTitle"),
    //                 text: result.message || t("createWarehouse") + " failed",
    //                 confirmButtonColor: "#d33",
    //             });
    //         }

    //     } catch (error) {
    //         console.error("Warehouse creation error:", error);

    //         Swal.fire({
    //             icon: "error",
    //             title: t("errorTitle"),
    //             text: t("somethingWrong"),
    //             confirmButtonColor: "#d33",
    //         });

    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleWarehouse = async () => {
        try {
            const warehouseValues = await warehouseForm.validateFields();

            if (!isValidGoogleMapsEmbedUrl(warehouseValues.map)) {
                message.error("Please enter a valid Google Maps embed URL.");
                return;
            }

            if (!step1Values) {
                console.error("Step 1 values missing!");
                return;
            }

            setLoading(true);

            const formData = new FormData();

            // User values
            formData.append("name", step1Values.name);
            formData.append("email", step1Values.email);
            formData.append("phone_no", step1Values.phone);
            formData.append("password", step1Values.password);
            formData.append("role", step1Values.role);

            // Warehouse values
            formData.append("region", warehouseValues.region);
            formData.append("wh_name", warehouseValues.warehouseName);
            formData.append("map", warehouseValues.map || "");
            formData.append("address", warehouseValues.address);
            formData.append("district", warehouseValues.district || "");
            formData.append("pincode", warehouseValues.pincode || "");
            formData.append("ofc_phn", warehouseValues.ofc_phone || "");
            formData.append("total_capacity", warehouseValues.total_capacity);

            const response = await authenticatedFetch(
                `${BASE_API}/apis/CreateWarehouse.php`,
                {
                    method: "POST",
                    body: formData
                }
            );

            // Session expired or invalid
            if (!response) return;

            const result = await response.json();

            if (response.ok && result.status === "success") {
                Swal.fire({
                    icon: "success",
                    title: t("successTitle"),
                    text: result.message || t("createWarehouse") + " " + t("successTitle"),
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "OK",
                });

                userForm.resetFields();
                warehouseForm.resetFields();

                setCurrentStep(0);

                handleClose();

                await fetchWarehouselist();

            } else {
                Swal.fire({
                    icon: "error",
                    title: t("errorTitle"),
                    text: result.message || t("createWarehouse") + " failed",
                    confirmButtonColor: "#d33",
                });
            }

        } catch (error) {
            console.error("Warehouse Creation Error:", error);

            Swal.fire({
                icon: "error",
                title: t("errorTitle"),
                text: t("somethingWrong"),
                confirmButtonColor: "#d33",
            });

        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        const userValues = userForm.getFieldsValue();
        const warehouseValues = warehouseForm.getFieldsValue();

        const isUserFormEmpty = Object.values(userValues).every(
            (value) => !value
        );

        const isWarehouseFormEmpty = Object.values(warehouseValues).every(
            (value) => !value
        );

        if (isUserFormEmpty && isWarehouseFormEmpty) {
            setCurrentStep(0);
            handleCanvaClose();
            userForm.resetFields();
            warehouseForm.resetFields();
        } else {
            Swal.fire({
                title: t("unsavedTitle"),
                text: t("unsavedText"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: t("yesExit"),
            }).then((result) => {
                if (result.isConfirmed) {
                    setCurrentStep(0);
                    handleCanvaClose();
                    userForm.resetFields();
                    warehouseForm.resetFields();
                }
            });
        }
    };

    return (
        <Offcanvas
            show={show}
            onHide={() => handleClose()}
            placement="start"
            style={{ width: "800px" }}
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title className="text-primary">{t("createNewWarehouse")}</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body style={{ background: "#fafafa" }}>

                <Steps
                    current={currentStep}
                    style={{ marginBottom: 25 }}
                    items={[
                        { title: t("createUser") },
                        { title: t("warehouseDetails") }
                    ]}
                />

                <Divider />

                {/* ================= STEP 1 ================= */}
                {currentStep === 0 && (
                    <Form layout="vertical" form={userForm}>
                        <Row gutter={16}>

                            {/* Full Name */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("fullName")}
                                    name="name"
                                    getValueFromEvent={(e) =>
                                        allowEnglishTamilWithSpaceAndDot(e.target.value)
                                    }
                                    rules={[
                                        // {
                                        //     required: true,
                                        //     message: t("enterFullName"),
                                        // },
                                        {
                                            validator: (_, value) => {
                                                if (value?.trim()) {
                                                    return Promise.resolve();
                                                }

                                                return Promise.reject(
                                                    new Error(t("enterFullName"))
                                                );
                                            },
                                        },
                                    ]}
                                >
                                    <Input placeholder={t("enterFullName")} />
                                </Form.Item>
                            </Col>


                            {/* Email */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("email")}
                                    name="email"
                                    getValueFromEvent={(e) =>
                                        allowEmailCharacters(e.target.value)
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t("enterEmail"),
                                        },
                                        {
                                            type: "email",
                                            message: t("validEmail"),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={t("enterEmail")}
                                        maxLength={254}
                                    />
                                </Form.Item>
                            </Col>



                            {/* Phone */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("phone")}
                                    name="phone"
                                    rules={[
                                        {
                                            required: true,
                                            message: t("enterPhone"),
                                        },
                                        {
                                            validator: (_, value) => {
                                                if (!value) {
                                                    return Promise.resolve();
                                                }

                                                if (!isValidTenDigitPhone(value)) {
                                                    return Promise.reject(
                                                        new Error("Phone number must be exactly 10 digits")
                                                    );
                                                }

                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={t("enterPhone")}
                                        maxLength={10}
                                        inputMode="numeric"
                                        onChange={(e) => {
                                            const value = allowOnlyNumbers(e.target.value);

                                            // Update Ant Design form value
                                            userForm.setFieldValue("phone", value);
                                        }}
                                    />
                                </Form.Item>

                            </Col>

                            {/* Role */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("role")}
                                    name="role"
                                    rules={[{ required: true, message: t("selectRole") }]}
                                >
                                    <Select placeholder={t("selectRole")} style={{ width: "100%" }}>
                                        <Select.Option value="Manager">
                                            {t("warehouseManager")}
                                        </Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            {/* Password */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("password")}
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: t("enterPassword"),
                                        },
                                        {
                                            validator: (_, value) => {
                                                if (!value) {
                                                    return Promise.resolve();
                                                }

                                                if (value.length < 8) {
                                                    return Promise.reject(
                                                        new Error(t("passwordMin"))
                                                    );
                                                }

                                                if (!/[A-Z]/.test(value)) {
                                                    return Promise.reject(
                                                        new Error(t("passwordUppercase"))
                                                    );
                                                }

                                                if (!/[a-z]/.test(value)) {
                                                    return Promise.reject(
                                                        new Error(t("passwordLowercase"))
                                                    );
                                                }

                                                if (!/[0-9]/.test(value)) {
                                                    return Promise.reject(
                                                        new Error(t("passwordNumber"))
                                                    );
                                                }

                                                if (!/[!@#$%^&*(),.?":{}|<>_\-\\[\]\/`~;'+=]/.test(value)) {
                                                    return Promise.reject(
                                                        new Error(t("passwordSpecial"))
                                                    );
                                                }

                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password placeholder={t("enterPassword")} />
                                </Form.Item>
                            </Col>

                            {/* Confirm Password */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("confirmPassword")}
                                    name="confirmPassword"
                                    dependencies={["password"]}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: t("confirmYourPassword"),
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue("password") === value) {
                                                    return Promise.resolve();
                                                }

                                                return Promise.reject(
                                                    new Error(t("passwordMismatch"))
                                                );
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password placeholder={t("confirmYourPassword")} />
                                </Form.Item>
                            </Col>
                            <div className="text-muted small">
                                <strong>{t("passwordRequirementTitle")}</strong>
                                <div>• {t("passwordMin")}</div>
                                <div>• {t("passwordUppercase")}</div>
                                <div>• {t("passwordLowercase")}</div>
                                <div>• {t("passwordNumber")}</div>
                                <div>• {t("passwordSpecial")}</div>
                            </div>
                        </Row>

                        {/* Next Button */}
                        <div className="text-end mt-3">
                            <Button type="primary" onClick={handleNext}>
                                {t("next")}
                            </Button>
                        </div>
                    </Form>
                )}

                {/* ================= STEP 2 ================= */}
                {currentStep === 1 && (
                    <Form layout="vertical" form={warehouseForm}>
                        <Row gutter={16}>

                            {/* Region */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("region")}
                                    name="region"
                                    rules={[
                                        {
                                            required: true,
                                            message: t("pleaseSelectRegion")
                                        }
                                    ]}
                                >
                                    <Select
                                        placeholder={t("chooseRegion")}
                                        style={{ width: "100%" }}
                                    >
                                        {region?.map((item, index) => (
                                            <Option
                                                key={index}
                                                value={item?.region_id}
                                            >
                                                {item?.region_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>


                            {/* Warehouse Name */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("warehouseName")}
                                    name="warehouseName"
                                    getValueFromEvent={(e) =>
                                        allowLettersNumbersUnicodeWithSpace(e.target.value)
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t("enterWarehouseName")
                                        }
                                    ]}
                                >
                                    <Input placeholder={t("enterWarehouseName")} />
                                </Form.Item>
                            </Col>


                            {/* Address */}
                            <Col span={24}>
                                <Form.Item
                                    label={t("address")}
                                    name="address"
                                    getValueFromEvent={(e) =>
                                        allowAddressCharacters(e.target.value)
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t("enterAddress")
                                        }
                                    ]}
                                >
                                    <Input.TextArea
                                        rows={3}
                                        placeholder={t("enterAddress")}
                                    />
                                </Form.Item>
                            </Col>


                            {/* District */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("district")}
                                    name="district"
                                    getValueFromEvent={(e) =>
                                        allowEnglishTamilWithSpace(e.target.value)
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t("enterDistrict")
                                        }
                                    ]}
                                >
                                    <Input placeholder={t("enterDistrict")} />
                                </Form.Item>
                            </Col>


                            {/* Pincode */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("pincode")}
                                    name="pincode"
                                    rules={[
                                        {
                                            required: true,
                                            message: t("enterPincode")
                                        },
                                        {
                                            validator: (_, value) => {
                                                if (!value) {
                                                    return Promise.resolve();
                                                }

                                                if (isValidSixDigitPincode(value)) {
                                                    return Promise.resolve();
                                                }

                                                return Promise.reject(
                                                    new Error(t("validPincode"))
                                                );
                                            }
                                        }
                                    ]}
                                >
                                    <Input
                                        placeholder={t("enterPincode")}
                                        maxLength={6}
                                        inputMode="numeric"
                                        onChange={(e) => {
                                            const value = allowOnlyNumbers(e.target.value);
                                            warehouseForm.setFieldValue("pincode", value);
                                        }}
                                    />
                                </Form.Item>
                            </Col>


                            {/* Office Phone */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("officePhone")}
                                    name="ofc_phone"
                                    getValueFromEvent={(e) =>
                                        allowPhoneCharacters(e.target.value)
                                    }
                                    rules={[
                                        {
                                            required: false
                                        }
                                    ]}
                                >
                                    <Input
                                        placeholder={t("officePhone")}
                                        inputMode="tel"
                                    />
                                </Form.Item>
                            </Col>


                            {/* Total Capacity */}
                            <Col span={12}>
                                <Form.Item
                                    label={t("totalCapacity")}
                                    name="total_capacity"
                                    getValueFromEvent={(e) =>
                                        allowNumbersWithSpace(e.target.value)
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: t("enterCapacity")
                                        }
                                    ]}
                                >
                                    <Input
                                        placeholder={t("enterCapacity")}
                                        inputMode="numeric"
                                    />
                                </Form.Item>
                            </Col>





                            <Col span={24}>
                                <Form.Item
                                    label={t("map")}
                                    name="map"
                                    rules={[{ required: true, message: t("enterMap") }]}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <Input style={{ flex: 1 }} placeholder={t("enterMap")} />

                                        <div className="d-flex align-items-center" style={{ whiteSpace: "nowrap" }}>
                                            <button
                                                type="button"
                                                className="btn btn-sm text-primary p-0 me-1"
                                                onClick={() => setShowVideo(true)}
                                                title={t("demo")}
                                                style={{ fontSize: "1.2rem" }}
                                            >
                                                <i className="bi bi-play-circle-fill"></i>
                                            </button>
                                            <span className="fs-6 text-secondary mb-0">
                                                {t("demo")}
                                            </span>
                                        </div>
                                    </div>
                                </Form.Item>
                            </Col>

                            {/* Modal */}
                            <Modal
                                show={showVideo}
                                onHide={() => setShowVideo(false)}
                                size="lg"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>{t("demoVideo")}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="ratio ratio-16x9">
                                        <video
                                            src={`${BASE_API}/images/demovideo/map.mp4`}
                                            autoPlay
                                            controls
                                            muted
                                        />
                                    </div>
                                </Modal.Body>
                            </Modal>

                        </Row>

                        <div className="d-flex justify-content-between mt-3">
                            <Button onClick={() => setCurrentStep(0)}>
                                {t("previous")}
                            </Button>

                            <Button type="primary" onClick={handleWarehouse} loading={loading}>
                                {t("createWarehouse")}
                            </Button>
                        </div>
                    </Form>
                )}

            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default NewWarehouse;